<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Motivo do atendimento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.geral.ciap"
                        :request-query-string-params="{
                            sexo_id: data.additionals.paciente.sexoId,
                            show_all: true,
                            not_in: [
                                enums.ciap.MEDICINA_FISICA_REABILITACAO,
                                enums.ciap.TUBERCULOSE,
                                enums.ciap.DENGUE_E_OUTRAS_DOENCAS_VIRAIS_NE,
                                enums.ciap.HANSENIASE_E_OUTRAS_DOENCAS_INFECCIOSAS_NE,
                                enums.ciap.FATOR_DE_RISCO_PARA_DOENCA_CARDIOVASCULAR,
                                enums.ciap.HIPERTENSAO_SEM_COMPLICACOES,
                                enums.ciap.ABUSO_AGUDO_DE_ALCOOL,
                                enums.ciap.ABUSO_DO_TABACO,
                                enums.ciap.ABUSO_DE_DROGAS,
                                enums.ciap.DOENCA_PULMONAR_OBSTRUTIVA_CRONICA,
                                enums.ciap.ASMA,
                                enums.ciap.OBESIDADE,
                                enums.ciap.DIABETES_NAO_INSULINO_DEPENDENTE,
                                enums.ciap.DEFICIENCIA_VITAMINICA_NUTRICIONAL,
                                enums.ciap.SINAIS_SINTOMAS_POS_PARTO,
                                enums.ciap.MEDICINA_PREVENTIVA_MANUTENCAO_DA_SAUDE
                            ],
                        }"
                        :results-limit= "20"
                        :search-fields="fields.ciap"
                        :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                        :validations="validations.ciap"
                        @select="handleCiapSelect"
                        label="CIAP 2"
                        v-model="model.ciap"
                    />
                </rkm-col>

                <rkm-col cols="6" v-if="!model.sugestao">
                    <rkm-form-input-autocomplete
                        :disabled="isGravidezNormal(model)"
                        :repository="repositories.cid"
                        :request-query-string-params="{
                            ciap_id: model.ciap ? model.ciap.id : null,
                            sexo: data.additionals.paciente.sexoIdentificador,
                        }"
                        :results-limit= "20"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.cid"
                        label="CID 10"
                        v-model="model.cid"
                    >

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    v-model="model.sugestao"
                                    :disabled="data.cidSugestao.length === 0 || isGravidezNormal(model)"
                                >
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="6" v-else>
                    <rkm-form-select
                        :disabled="isGravidezNormal(model)"
                        :options="data.cidSugestao"
                        label="CID 10"
                        show-default-option
                        text-field="codigoNome"
                        v-model="model.cidId"
                        value-field="id"
                        :validations="validations.cid"
                    >

                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.sugestao">
                                    <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                    <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Enums.
import ciap from '@/enums/geral/ciap'
import grupoCiap from '@/enums/geral/grupoCiap'

// Mixins.
import {ambulatorioAtendimentoPreNatal, ambulatorioAtendimentoProblemaCondicao, object, repository} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                ciap: {required: !this.model.cid && !this.model.cidId},
                cid: {required: !this.model.ciap},
                observacao: {max: 500},
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {ciap},
        fields: {
            ciap: [
                {key: 'geral_ciap.codigo', searchable: true},
                {key: 'geral_ciap.descricao', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
        },
        item: null,
        model: {
            ciap: null,
            cid: null,
            observacao: null,
            sugestao: false,
            cidId: null
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                ciap: this.item.ciap,
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 ? this.item.cid.id : null,
                observacao: this.item.observacao,
                sugestao: false,
            })
        },
        store() {

                        let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            this.data.model.motivos.push({
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                cid: cid,
                observacao: this.model.observacao,
            })

            let problemaCondicaoPaciente = null

            if (this.model.ciap && this.model.cid) {
                problemaCondicaoPaciente = this.getProblemasCondicoesPaciente()
                    .filter(problemaCondicaoPaciente => {
                        if (problemaCondicaoPaciente.ciap) {
                            return problemaCondicaoPaciente.ciap.id === this.model.ciap.id
                        }
                    })
                    .filter(problemaCondicaoPaciente => {
                        if (problemaCondicaoPaciente.cid) {
                            return problemaCondicaoPaciente.cid.id === this.model.cid.id
                        }
                    })[0]
            } else {
                if (this.model.ciap) {
                    problemaCondicaoPaciente = this.getProblemaCondicaoPacienteByCiapId(this.model.ciap.id)
                }
                else if (this.model.cid) {
                    problemaCondicaoPaciente = this.getProblemaCondicaoPacienteByCidId(this.model.cid.id)
                }
            }

            if (problemaCondicaoPaciente) {
                const problemaCondicaoPreparado = this.getPreparedProblemaCondicaoPaciente(problemaCondicaoPaciente)

                problemaCondicaoPreparado.id = problemaCondicaoPreparado.problemaCondicaoPacienteId
                delete problemaCondicaoPreparado.problemaCondicaoPacienteId

                this.data.avaliacaoModel.problemasCondicoes.push(problemaCondicaoPreparado)
            } else {
                this.data.avaliacaoModel.problemasCondicoes.push({
                    automatico: false,
                    id: null,
                    ciap: this.model.ciap ? {
                        id: this.model.ciap.id,
                        codigo: this.model.ciap.codigo,
                        descricao: this.model.ciap.descricao,
                    } : null,
                    cid: cid,
                    incluirListaPaciente: false,
                    situacaoId: null,
                    situacaoNome: null,
                    inicio: null,
                    fim: null,
                    observacao: this.model.observacao,
                })
            }
        },
        update() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            Object.assign(this.item, {
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                cid: cid,
                observacao: this.model.observacao,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.ciap !== null && this.model.cid !== null) {
                        const isCiapGravidez = this.ciapsGravidez.normal.concat(this.ciapsGravidez.altoRisco).includes(this.model.ciap.codigo)
                        const isCidGravidez = this.cidsGravidez.normal.concat(this.cidsGravidez.altoRisco).includes(this.model.cid.codigo)
                        const isCiapDesfechoGravidez = this.ciapsGravidez.desfecho.includes(this.model.ciap.codigo)
                        const isCidDesfechoGravidez = this.cidsGravidez.desfecho.includes(this.model.cid.codigo)

                        if (isCiapGravidez && isCidDesfechoGravidez) {
                            this.showValidationNotification(
                                `CIAP de pré-natal não pode ser registrada com CID de desfecho da gestação.
                                Registre o desfecho em outro motivo.`
                            )
                            return
                        }

                        if (isCiapDesfechoGravidez && isCidGravidez) {
                            this.showValidationNotification(
                                `CIAP de desfecho da gestação não pode ser registrada com CID de pré-natal.
                                Registre o pré-natal em outro motivo.`
                            )
                            return
                        }
                    }

                    if(this.model.ciap != null && (this.model.ciap.grupoId === grupoCiap.PROCEDIMENTOS)){
                        this.showValidationNotification('Ciap do grupo de procedimentos não pode ser utilizado aqui.')
                        return
                    }

                    const hasGravidezNormal = this.data.additionals.hasGravidezNormal
                        || this.data.model.motivos.some(motivo => {
                            if (motivo.ciap && this.ciapsGravidez.normal.includes(motivo.ciap.codigo)) {
                                return true
                            }

                            if (motivo.cid && this.cidsGravidez.normal.includes(motivo.cid.codigo)) {
                                return true
                            }
                        })

                    if (hasGravidezNormal && this.isDesfechoGravidez(this.model)) {
                        this.showValidationNotification('Para registrar desfecho de gravidez remova a condição de pré-natal.')
                        return
                    }

                    const hasDesfechoGravidez = this.data.additionals.hasDesfechoGravidez
                        || this.data.model.motivos.some(motivo => {
                            if (motivo.ciap && this.ciapsGravidez.desfecho.includes(motivo.ciap.codigo)) {
                                return true
                            }

                            if (motivo.cid && this.cidsGravidez.desfecho.includes(motivo.cid.codigo)) {
                                return true
                            }
                        })

                    if (hasDesfechoGravidez && this.isGravidezNormal(this.model)) {
                        this.showValidationNotification('Para registrar pré-natal remova a condição de desfecho de gravidez.')
                        return
                    }

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.ciap = null
            this.model.cid = null
            this.model.cidId = null
            this.model.observacao = null
            this.model.sugestao = false
        },
        getProblemasCondicoesPaciente() {
            return this.data.avaliacaoForm.problemaCondicao.problemasCondicoesPaciente
        },
        getProblemaCondicaoPacienteByCiapId(id) {
            return this.getProblemasCondicoesPaciente().find(problemaCondicaoPaciente => {
                if (problemaCondicaoPaciente.ciap) {
                    return problemaCondicaoPaciente.ciap.id === id
                }
            })
        },
        getProblemaCondicaoPacienteByCidId(id) {
            return this.getProblemasCondicoesPaciente().find(problemaCondicaoPaciente => {
                if (problemaCondicaoPaciente.cid) {
                    return problemaCondicaoPaciente.cid.id === id
                }
            })
        },
        handleCiapSelect(value) {
            if (value.cidId) {

                this.model.sugestao = false

                this.model.cid = {
                    id: value.cidId,
                    codigo: value.cidCodigo,
                    nome: value.cidNome,
                }
            }
        },
    },
    mixins: [ambulatorioAtendimentoPreNatal, ambulatorioAtendimentoProblemaCondicao, object, repository],
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'model.ciap'(value) {
            if (!value) {
                this.model.cid = null
                this.model.cidId = null
                this.model.sugestao = null
            }
        },
    },
}
</script>